// extracted by mini-css-extract-plugin
export var layoutContainer = "_4l-0";
export var layoutContainerNoRounding = "_4l-6";
export var layoutContainerOpen = "_4l-5";
export var layoutContainerResizing = "_4l-1";
export var mainContent = "_4l-2";
export var resizeDivider = "_4l-3";
export var slidePanel = "_4l-4";